export default "__VITE_ASSET__f__U0xui__"